import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";

import {TimeoutDirective} from "./timeout.directive";
import {TimeoutComponent} from "./timeout.component";
import {TimeoutService} from "./timeout.service";


export class ShTimeoutModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule
  ],
  declarations: [
    TimeoutDirective,
    TimeoutComponent
  ],
  exports: [
    TimeoutDirective,
    TimeoutComponent
  ],
  providers: [
    TimeoutService
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
